import { CHANNEL_RULES } from '@gr/core/distribution/channels/channel-types';
import type { ChannelDto } from '@gr/core/distribution/channels/dto';
import type { FieldValue } from '@gr/core/content/entities/fields';
import { parseHashtagInput } from '@gr/core/content/posts/hashtags';
import type { PostDto, UpdatePostRequestDto } from '@gr/core/content/posts/dto';

/**
 * Правка поста в форме (POST-UC-2, POST-UC-11, POST-UC-12): теги — строкой «#тег #тег», как их
 * вводят; правило оформления — '' для правила по умолчанию.
 */
export interface PostDraft {
  title: string;
  body: string;
  tags: string;
  customValues: Record<string, FieldValue>;
  formatId: string;
  notes: string;
}

export const POST_DRAFT_FIELDS = ['title', 'body', 'tags', 'customValues', 'formatId', 'notes'] as const;

export function draftOf(post: Pick<PostDto, 'title' | 'body' | 'tags' | 'customValues' | 'formatId' | 'notes'>): PostDraft {
  return {
    title: post.title,
    body: post.body,
    tags: post.tags.map((tag) => `#${tag}`).join(' '),
    customValues: { ...post.customValues },
    formatId: post.formatId ?? '',
    notes: post.notes,
  };
}

export function updateRequestOf(draft: PostDraft): UpdatePostRequestDto {
  return {
    title: draft.title,
    body: draft.body,
    tags: parseHashtagInput(draft.tags),
    customValues: draft.customValues,
    formatId: draft.formatId || null,
    notes: draft.notes,
  };
}

/** Самый строгий лимит подписи среди активных каналов — для счётчика символов; null — лимитов нет. */
export function strictestCaptionLimit(channels: readonly Pick<ChannelDto, 'active' | 'type'>[]): number | null {
  const limits = channels.filter((c) => c.active).map((c) => CHANNEL_RULES[c.type].captionLimit).filter((n): n is number => n !== null);
  return limits.length > 0 ? Math.min(...limits) : null;
}
